__webpack_require__.p = "/training/";